<template>
    <div class="card">
        <div class="card-title">
            {{ test.testName }}
        </div>
        <div class="card-description">
            Тест пройден {{ test.testingDatetimeEnd | dateFormat('DD MMMM YYYY в HH:mm') }}
        </div>
        <div v-if="test.status === 'in_check'" class="card-checking">
            На проверке
        </div>
        <div v-else class="card-result">
            <span class="card-text">
                Набрано баллов
            </span>
            <span class="card-value">
                {{ `${test.score}/${test.maxScore}` }}
            </span>
        </div>
        <div class="card-actions-row">
            <div
                class="hover-link-underlined card-link"
                @click="$emit('on-show-result', test)"
            >
                Посмотреть результаты
            </div>
        </div>
    </div>
</template>

<script>
import dateFormat from "@/filters/moment-date";

export default {
    name: "TestCompletedCard",

    filters: {
        dateFormat,
    },

    props: {
        test: {
            type: Object,
            default: () => {
            },
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/rem';

.card {
    display: flex;
    flex-flow: column nowrap;
    justify-content: flex-start;
    align-items: flex-start;
    padding: rem(24);
    border-radius: rem(4);
    background-color: #FFFFFF;
    box-shadow: 0 rem(6) rem(10) rgba(131, 134, 163, 0.12);

    @include on-mobile {
        padding: mrem(16);
        border-radius: mrem(4);
        box-shadow: 0 mrem(6) mrem(10) rgba(131, 134, 163, 0.12);
    }

    &-title {
        margin: 0 0 rem(16) 0;
        font-weight: 600;
        font-size: rem(16);
        line-height: rem(24);
        color: #2A2626;

        @include on-mobile {
            margin: 0 0 mrem(16) 0;
            font-size: mrem(15);
            line-height: mrem(22);
        }
    }

    &-text, &-description, &-value, &-checking {
        font-size: rem(14);
        line-height: rem(20);
        color: #2A2626;

        @include on-mobile {
            font-size: mrem(14);
            line-height: mrem(20);
        }
    }

    &-description {
        margin: 0 0 rem(8) 0;

        @include on-mobile {
            margin: 0 0 mrem(8) 0;
        }
    }

    &-result, &-checking {
        margin: 0 0 rem(16) 0;

        @include on-mobile {
            margin: 0 0 mrem(16) 0;
        }
    }

    &-value {
        font-weight: 600;
    }

    &-checking {
        font-weight: 600;
        color: #F24D6C;
    }

    &-actions-row {
        width: 100%;
        text-align: right;
        margin: auto 0 0 0;
    }

    &-link {
        font-size: rem(14);
        line-height: rem(17);

        @include on-mobile {
            font-size: mrem(14);
            line-height: mrem(17);
        }
    }
}
</style>
